module.exports = __webpack_public_path__ + "media/fonts/Oricons-58a81b2b5994a112fb654f0af16541e7.woff2";